/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { get, CashRequestOptions, SerializeQueryParameters } from '@cash-web/shared-util-fetch'
import {BrowseMarketplaceRequest} from '@cash-web/protos/squareup/cash/local/client/v1/local_marketplace.pb'
import {BrowseMarketplaceResponse} from '@cash-web/protos/squareup/cash/local/client/v1/local_marketplace.pb'


export const browseMarketplace = (params?: SerializeQueryParameters, options?: CashRequestOptions) => get<BrowseMarketplaceResponse>("/cash-app/local/marketplace/browse", params, {...options, rejectOnError: true })